import React from 'react';

import { Badge } from '@ergeon/core-components';

interface CustomerContextMessageProps {
  name?: string | null;
  primaryEmail?: string | null;
  primaryPhone?: string | null;
  marketName?: string | null;
  isCommercial?: boolean | null;
  isKeyAccount?: boolean | null;
  businessName?: string | null;
}

export const CustomerContextMessage: React.FC<CustomerContextMessageProps> = ({
  name,
  primaryEmail,
  primaryPhone,
  marketName,
  isCommercial,
  isKeyAccount,
  businessName,
}) => {
  return (
    <div className="flex flex-col justify-start gap-1 w-full text-left">
      {name && (
        <div className="flex flex-col gap-1">
          <strong>{name}</strong>
          {businessName && isCommercial && <div className="paragraph-2">{businessName}</div>}
        </div>
      )}

      {(primaryPhone || primaryEmail || marketName) && (
        <div className="flex flex-col gap-1 paragraph-2">
          {primaryPhone && <span>Phone: {primaryPhone}</span>}
          {primaryEmail && <span>Email: {primaryEmail}</span>}
          {marketName && <span>Market: {marketName}</span>}
        </div>
      )}

      {(isCommercial || isKeyAccount) && (
        <div className="flex gap-2">
          {isCommercial && <Badge flavor="primary" value="Commercial" />}
          {isKeyAccount && <Badge flavor="success" value="Key Account" />}
        </div>
      )}
    </div>
  );
};
